import { render, staticRenderFns } from "./ChoicePaymentInstalment.vue?vue&type=template&id=025f82f4&scoped=true&"
import script from "./ChoicePaymentInstalment.vue?vue&type=script&lang=js&"
export * from "./ChoicePaymentInstalment.vue?vue&type=script&lang=js&"
import style0 from "./ChoicePaymentInstalment.vue?vue&type=style&index=0&id=025f82f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f82f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('025f82f4')) {
      api.createRecord('025f82f4', component.options)
    } else {
      api.reload('025f82f4', component.options)
    }
    module.hot.accept("./ChoicePaymentInstalment.vue?vue&type=template&id=025f82f4&scoped=true&", function () {
      api.rerender('025f82f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/services/payments/ChoicePaymentInstalment.vue"
export default component.exports